import BarLottieData from '@/static/assets/renters/loader.json';
import { Flex, useLottie } from '@lemonade-hq/cdk';
import parser from 'html-react-parser';
// import dynamic from 'next/dynamic';
import React from 'react';
import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { mergeRefs } from 'react-merge-refs';
import { Subtitle, Title } from './shared/ContentStyling';

import { MotionStuffLotties } from './MotionStuffLotties';

export interface GetCoveredProps {
  title: string;
  subtitle: string;
  showBundleSection?: boolean;
}

const Bar = () => {
  const { ref, inView } = useInView();
  const barRef = useRef<HTMLDivElement>(null);

  const barLottie = useLottie(barRef, {
    animationData: BarLottieData,
    lottieConfig: {
      loop: false,
      autoplay: true,
    },
    scrollOptions: {
      playTrigger: {
        y: {
          condition: 'intersect',
          threshold: 0.2,
        },
        pauseIfConditionsUnmet: true,
      },
    },
  });

  useEffect(() => {
    if (barLottie && inView) {
      barLottie.goToAndStop(0);
    }
  }, [barLottie, inView]);
  return (
    <Flex
      ref={mergeRefs([barRef, ref])}
      mb={[347, 277, 347, 347]}
      width={[270, 270, 270, 390]}
      height={[70, 70, 70, 100]}
      alignItems="center"
      justifyContent="center"
      zIndex={0}
    />
  );
};

export const GetCovered: React.FC<GetCoveredProps> = ({ title, subtitle }) => {
  return (
    <Flex position="relative" mt={0}>
      <MotionStuffLotties />
      <Flex
        width="100%"
        alignItems="center"
        textAlign="center"
        flexDirection="column"
        zIndex={3}
        pt={[0, 100, 100, 100]}
        pb={[140, 0, 0, 0]}
        px={10}
        position="relative"
      >
        <Title>{title}</Title>
        <Subtitle mt={20} mb={[0, 0, 0, 20]}>
          {parser(subtitle)}
        </Subtitle>
        <Bar />
      </Flex>
    </Flex>
  );
};
